import {usePathname} from 'next/navigation';

import {AccessHeader, UseAccessWrapperResult} from './types';

export function useAccessWrapper(
  nonProtectedRoutes: string[],
  headerList: AccessHeader[] = []
): UseAccessWrapperResult {
  const pathname = usePathname();
  if (nonProtectedRoutes.includes(pathname)) {
    return {
      isAccess: true
    };
  }
  const lowerPath = pathname.toLowerCase();
  const currentHeader = headerList.find((item) => item.url.toLowerCase() === lowerPath && item.isAccess) || null;
  return {
    isAccess: !!currentHeader
  };
}
